import { useTranslation } from 'react-i18next';
import TextField from 'shared/components/form/TextField';
import { UpdateFormT } from 'shared/form-values/groups';

const Form = () => {
  const { t } = useTranslation();

  const fieldProps = {
    mb: '20px',
    w: {
      base: '100%',
      md: '50%',
    },
  };

  return (
    <>
      <TextField<UpdateFormT>
        name="name"
        label={t('services.table.name')}
        placeholder={t('services.table.name')}
        required
        {...fieldProps}
      />
      <TextField<UpdateFormT>
        name="note"
        label={t('services.table.note')}
        placeholder={t('services.table.note')}
        required
        {...fieldProps}
      />
      <TextField<UpdateFormT>
        name="link"
        label={t('services.table.link')}
        placeholder={t('services.table.link')}
        required
        {...fieldProps}
      />
      <TextField<UpdateFormT>
        name="sheetLink"
        label={t('services.table.sheetLink')}
        placeholder={t('services.table.sheetLink')}
        required
        {...fieldProps}
      />
    </>
  );
};

export default Form;
